import cx from 'classnames';
import { node, shape, string } from 'prop-types';
import React from 'react';
import style from './PageContainer.module.scss';

const PageContainer = ({ children, className, style: styleObj, ...rest }) => (
  <div
    className={cx(style.container, className)}
    style={{
      ...styleObj,
    }}
    {...rest}
  >
    {children}
  </div>
);

PageContainer.propTypes = {
  children: node.isRequired,
  className: string,
  style: shape({}),
};

PageContainer.defaultProps = {
  className: undefined,
  style: {},
};

export default PageContainer;
